import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestRoles() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/role`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRole(roleId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/role/${roleId}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRoleExpandedPermissions(roleId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/role/${roleId}/expanded-permissions`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRoleUsers(roleId, params) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/role/${roleId}/users`,
        withCredentials: true,
        crossorigin: true,
        params,
    });
}

export function requestCreateRole(roleData) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/role`,
        withCredentials: true,
        crossorigin: true,
        data: roleData,
    });
}

export function requestUpdateRole(roleId, roleData) {   
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/role/${roleId}`,
        withCredentials: true,
        crossorigin: true,
        data: roleData,
    });
}

export function requestDeleteRole(roleId, migrateTo) {
    return axios.request({
        method: "delete",
        url: `${getApiUrl()}/role/${roleId}`,
        params: migrateTo ? { migrateTo } : undefined,
        withCredentials: true,
        crossorigin: true,
    });
}
